if (!customElements.get('szx-native-bundle')) {
  customElements.define('szx-native-bundle', class extends HTMLElement {
    connectedCallback() {
      this.product = JSON.parse(this.querySelector('[data-szx-bundle-product]').textContent);
      this.text = JSON.parse(this.querySelector('[data-szx-bundle-text]').textContent);
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.info = this.closest('product-info');
      this.money = value => new Intl.NumberFormat(this.dataset.locale || 'de-DE', {style:'currency',currency:this.dataset.currency}).format(value / 100);
      this.onChange = event => {
        const row = event.target.closest('.szx-bundle-row');
        if (row) this.updateImage(row);
        this.updateCards();
      };
      this.addEventListener('change', this.onChange);
      this.onVariantChange = event => {
        if (event.target.name !== 'id') return;
        const variant = this.product.variants.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        this.querySelectorAll('.szx-bundle-row').forEach(row => {
          row.querySelectorAll('select').forEach(select => select.value = variant.options[Number(select.dataset.optionIndex)]);
          this.updateImage(row);
        });
        this.updateCards();
      };
      this.form.addEventListener('change', this.onVariantChange);
      this.onSubmit = event => {
        const items = this.selectedVariants();
        if (!items.length || items.some(v => !v?.available)) {
          event.preventDefault();event.stopImmediatePropagation();
          this.querySelector('.szx-bundle-status').textContent = this.text.unavailable;
        }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.onFormData = event => {
        const variants = this.selectedVariants();
        if (!variants.length || variants.some(v => !v?.available)) return;
        if (variants.length === 1) {
          event.formData.set('id',String(variants[0].id));event.formData.set('quantity','1');return;
        }
        event.formData.delete('id');event.formData.delete('quantity');
        const items = new Map();variants.forEach(v => items.set(v.id, (items.get(v.id) || 0) + 1));
        [...items].forEach(([id,quantity],i) => {
          event.formData.set(`items[${i}][id]`,String(id));
          event.formData.set(`items[${i}][quantity]`,String(quantity));
        });
      };
      this.form.addEventListener('formdata', this.onFormData);
      this.querySelectorAll('.szx-bundle-row').forEach(row => this.updateImage(row));
      this.updateCards();
    }
    disconnectedCallback() {
      this.removeEventListener('change',this.onChange);
      this.form?.removeEventListener('change',this.onVariantChange);
      this.form?.removeEventListener('submit',this.onSubmit,true);
      this.form?.removeEventListener('formdata',this.onFormData);
    }
    rowVariant(row) {
      const values = [...row.querySelectorAll('select')].map(select => select.value);
      return this.product.variants.find(v => v.options.every((value,i) => value === values[i]));
    }
    selectedVariants() {
      const card = this.querySelector('input[type="radio"]:checked')?.closest('.szx-bundle-card');
      return [...(card?.querySelectorAll('.szx-bundle-row') || [])].map(row => this.rowVariant(row));
    }
    updateImage(row) {
      const variant=this.rowVariant(row),image=row.querySelector('img');
      const source=variant?.featured_image?.src || this.product.featured_image;
      if (image && source) {
        image.removeAttribute('srcset');image.removeAttribute('sizes');
        image.src=source;image.alt=variant.options.join(' / ');image.dataset.variantId=String(variant.id);
      }
    }
    updateCards() {
      this.querySelector('.szx-bundle-status').textContent='';
      this.querySelectorAll('.szx-bundle-card').forEach(card => {
        const selected=card.querySelector('input').checked;
        card.classList.toggle('is-selected',selected);card.querySelector('.szx-bundle-rows').hidden=!selected;
        const variants=[...card.querySelectorAll('.szx-bundle-row')].map(row=>this.rowVariant(row));
        if (variants.some(v=>!v)) return;
        const count=Number(card.dataset.count),rate=[0,0,10.01,15][count];
        const subtotal=variants.reduce((s,v)=>s+v.price,0);
        const total=variants.reduce((s,v)=>s+v.price-Math.floor(v.price*rate/100),0);
        card.querySelector('.szx-bundle-total').textContent=this.money(total);
        const original=card.querySelector('.szx-bundle-original'),compare=count===1?(variants[0].compare_at_price || subtotal):subtotal;
        original.textContent=this.money(compare);original.hidden=compare<=total;
        if(count>1){card.querySelector('.szx-bundle-saving').textContent=this.money(subtotal-total)+' '+this.text.save;card.querySelector('.szx-bundle-unit').textContent=this.text.each+' '+this.money(Math.round(total/count));}
      });
    }
  });
}
